<template>
  <NavBar></NavBar>
  <BaseDrawer :is-open="isDrawerOpen && !isMeetingClicked" :speed="200" @close="closeDrawer">
    <div>
      <UpcomingMeeting></UpcomingMeeting>
    </div>
  </BaseDrawer>
  <div class="side-drawer">
    <button class="drawer-button" @click="toggleDrawer">
      <span class="material-symbols-outlined icon-button-to-primary">event_upcoming</span>
    </button>
    <button class="tb-drawer-button" @click="toggleTBReact">
      <span class="material-symbols-outlined icon-button-to-primary">chronic</span>
    </button>
    <button class="tb-drawer-button" :style="drawerButtonStyle" @click="toggleTBScheduler">
      <span class="material-symbols-outlined icon-button-to-primary">manage_accounts</span>
    </button>
  </div>
  <BaseDrawer :is-open="isMeetingClicked && !isAgendaPatientClicked" :speed="200" @close="agendaCloseDrawer">
    <div>
      <Agenda />
    </div>
  </BaseDrawer>
  <button v-if="isMeetingClicked && !isAgendaPatientClicked"></button>
  <BaseDrawer :is-open="isTBReactOpen" :speed="200" @close="closeDrawer" maxWidth="97.5%">
    <div class="old-tumor-board-column">
      <TumorBoardCardReact v-if="isTBReactOpen"></TumorBoardCardReact>
    </div>
  </BaseDrawer>
  <div v-if="isTBSchedulerOpen" class="tb-scheduler-view">
    <div class="tb-scheduler-column">
      <AdminTumorBoard />
    </div>
  </div>
  <div v-else class="desktop-view">
    <div class="info-column">
      <div class="card-container">
        <PatientCard></PatientCard>
      </div>
      <div class="card-container">
        <TumorBoardCard></TumorBoardCard>
      </div>
    </div>
    <div class="timeline-column">
      <div class="card-container">
        <div class="center-item">
          <ClinicalTimelineCard></ClinicalTimelineCard>
          <transition name="fade">
            <div class="center-modal" v-if="isCenterColumnOpen">
              <transition name="fade">
                <ReportViewerCard v-if="areReportsOpen" @close="onTestResultsClose"></ReportViewerCard>
              </transition>
              <transition name="fade">
                <GenomicsTestResults @close="onTestResultsClose" v-if="isGenomicsOpen"></GenomicsTestResults>
              </transition>
            </div>
          </transition>
        </div>
      </div>
    </div>
    <div class="diagnostics-column">
      <div class="diag-container">
        <DiagnosticsCard></DiagnosticsCard>
      </div>
    </div>
  </div>
  <div>
  <div class="diagnostics-column">
    <div class="diag-container">
      <DiagnosticsCard></DiagnosticsCard>
    </div>
  </div>
</div>
</template>

<script setup>
// Copyright (c) 2020-2023 dātma, inc™
// Copyright (c) 2023 datma, inc.
//
// Unauthorized copying of this file, via any medium is strictly prohibited
// Proprietary and confidential

import { computed, onMounted, ref, watch } from 'vue'
import { useStore } from 'vuex'
import NavBar from '@/ux3/components/NavBar.vue'
import BaseDrawer from '@/ux3/components/BaseDrawer/BaseDrawer.vue'
import PatientCard from '@/ux3/cards/PatientCard/PatientCard.vue'
import ClinicalTimelineCard from '@/ux3/cards/ClinicalTimelineCard/ClinicalTimelineCard.vue'
import DiagnosticsCard from '@/ux3/cards/DiagnosticsCard/DiagnosticsCard.vue'
import TumorBoardCard from '@/ux3/cards/TumorBoardCard/TumorBoardCard.vue'
import UpcomingMeeting from '@/ux3/cards/TumorBoardSideBar/UpcomingMeeting.vue'
import Agenda from '@/ux3/cards/TumorBoardSideBar/Agenda.vue'
import ReportViewerCard from '../../ux3/cards/ReportViewer/ReportViewerCard.vue'
import GenomicsTestResults from '@/ux3/components/Genomics/Results/GenomicsTestResults.vue'
import { closeCenterColumn } from '@/ux3/components/CenterColumnManagement/centerColumnManagement.js'
import TumorBoardCardReact from '@/ux3/cards/TumorBoardSchedulerReact/TumorBoardCardReact.vue'
import AdminTumorBoard from '../../ux3/cards/ManageTumorBoard/AdminTumorBoard.vue'

const store = useStore()
const patientId = computed(() => store.getters.session?.patient?.id || '')
const isCenterColumnOpen = computed(() => !!store.getters.session?.centerColumnState?.container)
const isGenomicsOpen = computed(() => !!store.getters.session?.centerColumnState?.genomics)
const areReportsOpen = computed(() => !!store.getters.session?.centerColumnState?.reports)

// when we select a new patient, close the Genomics card
watch(patientId, () => {
  onTestResultsClose()
  closeCenterColumn()
})

const onTestResultsClose = () => {
  closeCenterColumn()
}

const isMeetingClicked = computed(() => store.state.session.isUpcomingMeetingClicked)
const isAgendaPatientClicked = computed(() => store.state.session.isAgendaPatientClicked)
const isDrawerOpen = ref(false)
const isTBReactOpen = ref(false)
const isTBSchedulerOpen = ref(false)

const toggleTBScheduler = () => {
  isTBSchedulerOpen.value = !isTBSchedulerOpen.value
}

const toggleDrawer = () => {
  const isMeetingClicked = false
  isDrawerOpen.value = true
  store.dispatch('setUpcomingMeetingClicked', { isMeetingClicked, publish: true })
  store.dispatch('setAgendaPatientClicked', { isMeetingClicked, publish: true })
}

const toggleTBReact = () => {
  isTBReactOpen.value = !isTBReactOpen.value
}

const closeDrawer = () => {
  const isMeetingClicked = false
  isDrawerOpen.value = false
  isTBReactOpen.value = false
  store.dispatch('setUpcomingMeetingClicked', { isMeetingClicked, publish: true })
}

const agendaCloseDrawer = () => {
  const isMeetingClicked = false
  isDrawerOpen.value = false
  store.dispatch('setUpcomingMeetingClicked', { isMeetingClicked, publish: true })
}

onMounted(() => {
  const body = document.body
  document.documentElement.style.overflowY = 'hidden'
  body.style.overflowY = 'hidden'
  body.style.fontFamily = 'Roboto'
  const app = document.getElementById('app')
  app.style.position = 'static'  // fix body margin problem
  closeCenterColumn()
})

</script>

<style lang="scss" scoped>
.desktop-view {
  display: flex;
  margin-left: 4rem;
  width: calc(100% - 4rem);
  height: calc(100% - 70px);
}

.tb-scheduler-view {
  display: flex;
  margin-left: 4rem;
  width: calc(100% - 4rem);
  height: calc(100% - 70px);
}

.tb-scheduler-column {
  width: 100%;
  display: flex;
  flex-direction: column;
  height: calc(100% - 70px);
}

.info-column {
  width: 20%;
  display: flex;
  flex-direction: column;
  height: calc(100% - 70px);
}

.timeline-column {
  width: 55%;
  height: calc(100% - 70px);
}

.old-tumor-board-column {
  width: 100%;
  height: calc(100% - 70px);
}

.timeline-column .base-card {
  height: calc(100vh - (76px + 2rem));
}

.info-column .base-card {
  height: calc(50vh - 38px);
}

.diagnostics-column {
  width: 25%;
  background-color: var(--White);
  margin-left: 1rem;
  height: calc(100vh - 70px);
}

.test-results {
  height: calc(100vh - 70px);
}

.card-container {
  padding: 1rem;
  position: relative;
}

.center-modal {
  position: absolute;
  background-color: var(--White);
  width: calc(100% - 2rem);
  height: calc(100vh - (76px + 2rem));
  z-index: 100;
  top: 0;
  left: 0;
  border-radius: 16px;
  margin: 1rem;
  overflow: hidden;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 1s;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}

.side-drawer {
  background-color: var(--White);
  border-style: none;
  box-shadow: 0 0 3px #b9b9b9;
  width: 2.5rem;
  cursor: pointer;
  font: inherit;
  position: absolute;
  top: 71px;
  left: 0;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;

  &>span {
    display: block;
    margin: 0 auto;
    padding-top: 3rem;
  }
}

.drawer-button {
  outline: none;
  border: none;
  background-color: transparent;
  margin-top: 1rem;
  transition: all linear 200ms;
  cursor: pointer;
  color: var(--Grey600);

  &:hover {
    color: var(--Primary);
  }
}

.tb-drawer-button {
  outline: none;
  border: none;
  background-color: transparent;
  margin-top: 0.5rem;
  transition: all linear 200ms;
  cursor: pointer;
  color: var(--Grey600);

  &:hover {
    color: var(--Primary);
  }
}

.agenda-drawer-button {
  border-radius: 0 16px 16px 0;
  border-style: none;
  box-shadow: 0 0 3px #b9b9b9;
  width: 3rem;
  cursor: pointer;
  font: inherit;
  position: absolute;
  top: 0;
  left: 4rem;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: flex-start;

  &>span {
    display: block;
    margin: 0 auto;
    padding-top: 3rem;

    &>svg {
      width: 1.2rem;
    }
  }
}
</style>

<style type="scss">
.timeline-column .base-card {
  height: calc(96vh - 70px);
}

.info-column .base-card {
  height: calc(50vh - 70px);
}

.old-tumor-board-column .base-card {
  height: calc(96vh - 35px);
}

.tb-scheduler-column .base-card {
  height: calc(96vh - 35px);
}
</style>
